import HENGE from "@henge-inc/global-types";
import { ICON as ICON_v1_1 } from "@henge-inc/ui/v1_1";
import HUI from "@henge-inc/ui/v1_2";

export const BackButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <HUI.Button
      kind={HENGE.BUTTON_KIND.borderless}
      colour={HENGE.BUTTON_COLOUR.gray}
      icon={{
        icon: ICON_v1_1.ChevronLeft,
        kind: HENGE.ICON_KIND.regular,
        size: HENGE.DETAILED_SIZE.medium,
      }}
      onClick={onClick}
    />
  );
};
